export default __webpack_public_path__ + "static/studio-1-1-ee7711ad20cfc99c8c843805367d60a0.jpg";